"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const native_stack_1 = require("@react-navigation/native-stack");
const Routes_1 = __importDefault(require("./Routes"));
const screens_1 = require("../screens");
const Register_1 = require("../screens/Authentication/Register");
const Tutorial_1 = require("../screens/Authentication/Tutorial");
const SelectTag_1 = require("../screens/Authentication/SelectTag");
const AuthStack = (0, native_stack_1.createNativeStackNavigator)();
const AuthNavigator = () => {
    return (react_1.default.createElement(AuthStack.Navigator, { screenOptions: {
            headerShown: false,
            animation: "none",
        } },
        react_1.default.createElement(AuthStack.Screen, { name: Routes_1.default.LOGIN, component: screens_1.LoginScreen }),
        react_1.default.createElement(AuthStack.Screen, { name: Routes_1.default.TUTORIAL, component: Tutorial_1.TutorialScreen }),
        react_1.default.createElement(AuthStack.Screen, { name: Routes_1.default.SELECT_TAG, component: SelectTag_1.SelectTagScreen }),
        react_1.default.createElement(AuthStack.Screen, { name: Routes_1.default.REGISTER, component: Register_1.RegisterScreen }),
        react_1.default.createElement(AuthStack.Screen, { name: Routes_1.default.INPUT_PASSWORD, component: screens_1.InputPassword }),
        react_1.default.createElement(AuthStack.Screen, { name: Routes_1.default.FORGOT_PASSWORD, component: screens_1.ForgotPassword }),
        react_1.default.createElement(AuthStack.Screen, { name: Routes_1.default.CONFIRM_FORGOT, component: screens_1.ConfirmForgot }),
        react_1.default.createElement(AuthStack.Screen, { name: Routes_1.default.CHANGE_PASSWORD, component: screens_1.ChangePassword }),
        react_1.default.createElement(AuthStack.Screen, { name: Routes_1.default.NOTIFICATION_CHANGE_PASSWORD, component: screens_1.NotificationChangePass }),
        react_1.default.createElement(AuthStack.Screen, { name: Routes_1.default.URL_NOT_FOUND, component: screens_1.NotFoundScreen })));
};
exports.default = AuthNavigator;
